var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"instagram-media instagram-media-rendered",attrs:{"src":_vm.reel_id,"id":"instagram-embed-0","allowtransparency":"true","allowfullscreen":"true","frameborder":"0","height":"943","scrolling":"no"}})
}
var staticRenderFns = []

export { render, staticRenderFns }